module.exports = __webpack_public_path__ + "img/hold_btn.6bb3f02b.svg";